// tslint:disable:directive-selector
import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[maxDialog]'
})
export class MaxDialogDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}
